import { Reducer, createAction, createReducer } from "@reduxjs/toolkit";
import { Hoofdcode } from "@/models/hoofdcode";

export interface HoofdcodesState {
    data: Hoofdcode[],
    loaded: boolean
}

const initialState: HoofdcodesState = {
    data: [],
    loaded: false
}

const setDataAction = createAction<Hoofdcode[]>('hoofdcodes/set-data')
const clearDataAction = createAction('hoofdcodes/clear-data')

export const hoofdcodesReducer = createReducer(
    initialState,
    (builder) => {
        builder.addCase(setDataAction, (state, action) => {
            state.data = action.payload;
            state.loaded = true;
        }).addCase(clearDataAction, (state, action) => {
            state.data = [];
            state.loaded = false;
        })
    }
)

export const hoofdcodesActions = {
    set_data: setDataAction,
    clear_data: clearDataAction
}